<template><div><h1 id="umsatztypen" tabindex="-1"><a class="header-anchor" href="#umsatztypen"><span>Umsatztypen</span></a></h1>
<p>Umsatztypen — Definiert Umsatztypen für Personenumsätze</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Dient der näheren Bezeichnung von Geldwerten, die im System verarbeitet werden. Die Umsatztypen sind eng verbunden mit den Statistiken und Auswertungen und steuern den Status einer Person.</p>
<p>Pfad: <code v-pre>Personen → Tabellen → Umsatztypen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Umsatztyp</dt>
<dd>
<p>Bezeichnung, welcher u.a. in der Steuerung der Auftragsabwicklung und der Zusagenfakturierung verwendet wird.</p>
</dd>
<dt>Beschreibung</dt>
<dd>
<p>Längere Beschreibung des Umsatztyps.</p>
</dd>
<dt>bewirkt Personenstatus</dt>
<dd>
<p>Bewirkt eine Änderung des Status bei der Person, sobald ein entsprechender Umsatz verbucht wird.</p>
</dd>
<dd>
<p>leer = keine Statusveränderung</p>
</dd>
<dt>steuerrelevant</dt>
<dd>
<p>Dieser Umsatztyp wird zum steuerrelevanten Umsatz gerechnet (relevanter Umsatz für die Spendenbestätigungen).</p>
</dd>
</dl>
</div></template>


